export const selectDeliveryGroup = (deliveryGroup) => {
    return {
        type: 'LOWERING_DELIVERY_SELECT_ORDER_GROUP',
        deliveryGroup,
    };
};

export const updateDeliveryGroup = (deliveryGroup) => {
    return {
        type: 'UPDATE_LOWERING_DELIVERY_GROUP',
        deliveryGroup,
    };
};

export const resetDeliveryGroup = () => {
    return {
        type: 'RESET_LOWERING_DELIVERY_GROUP'
    };
};

export const setOrder = (order) => {
    return {
        type: 'LOWERING_DELIVERY_SELECT_ORDER',
        order,
    };
};

export const setOrders = (orders) => {
    return {
        type: 'LOWERING_DELIVERY_SELECT_ORDERS',
        orders,
    };
};

export const setNextPdu = (nextPdu) => {
    return {
        type: 'SET_NEXT_PDU',
        nextPdu
    };
};

export const updateMissionStatus = (orderItemId, status) => {
    return {
        type: 'UPDATE_LOWERING_DELIVERY_MISSION_STATUS',
        orderItemId,
        status
    };
};

export const updateOrderStatus = (orderId, status) => {
    return {
        type: 'UPDATE_LOWERING_DELIVERY_ORDER_STATUS',
        orderId,
        status
    };
};

export const resetOrder = () => {
    return {
        type: 'RESET_LOWERING_DELIVERY_ORDER'
    };
};

export const resetOrders = () => {
    return {
        type: 'RESET_LOWERING_DELIVERY_ORDERS'
    };
};

export const updateOrder = (order) => {
    return {
        type: 'LOWERING_DELIVERY_UPDATE_ORDER',
        order
    };
}

export const setDeliveryQrCodes = (qrCodes) => {
    return {
        type: 'LOWERING_DELIVERY_QRCODES',
        qrCodes
    };
}

export const setRouteLocationTargets = (routeLocationTargets) => {
    return {
        type: 'LOWERING_DELIVERY_ROUTE_LOCATIONTARGETS',
        routeLocationTargets,
    };
};

export const setRouteLocationTarget = (routeLocationTarget) => {
    return {
        type: 'SET_ROUTE_LOCATIONTARGET',
        routeLocationTarget,
    };
};